import { Injectable } from '@angular/core'
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
import { retry, switchMap, catchError } from 'rxjs/operators'
import { CurrentProductService } from '@spartacus/storefront'
import {
  AuthService,
  User,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { Observable, of, Subject, BehaviorSubject, throwError } from 'rxjs'
import { Product } from '../../models/product.model'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { environment } from '../../../environments/environment'
@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private menuSubject = new Subject<any>()

  guid: any
  cartId: any
  userType: any
  entryNumber: any
  product: Product = {}
  public showPriceCount = true

  private messageSource = new BehaviorSubject('default message')
  getMessage = this.messageSource.asObservable()

  private productSource = new BehaviorSubject({
    product: this.product,
    userType: '',
    cartId: '',
    type: '',
    quantity: 1,
  })
  getProduct = this.productSource.asObservable()

  private counterSource = new BehaviorSubject(1)
  passCount = this.counterSource.asObservable()

  public priceandAvailabilitySource = new BehaviorSubject(
    this.currentProductService.getProduct()
  )
  passPriceAndAvailablityProductCount =
    this.priceandAvailabilitySource.asObservable()

  private BOMProductSource = new BehaviorSubject([])
  getBOMPRoduct = this.BOMProductSource.asObservable()

  closeMenu = new BehaviorSubject({
    profileMenu: false,
    miniCart: false,
    megaNavMenu: false,
    changeAccMenu: false,
  })

  constructor(
    private http: HttpClient,
    private auth: AuthService,

    private currentProductService: CurrentProductService,
    private globalMessageService: GlobalMessageService,
    private userAccountFacade: UserAccountFacade
  ) {}

  public getData(API_URL: string, param?: any) {
    return this.http.get(API_URL, { params: param })
    /* return this.http.get(API_URL, { params: param }).pipe(
      retry(1)); */
  }
  public getData_Text(API_URL: string, param?: any) {
    return this.http.get(API_URL, { responseType: 'text', params: param })
  }
  public getData_WithoutRetry(API_URL: string, param?: any) {
    return this.http.get(API_URL, { params: param })
  }

  public getData_Excel(API_URL: string, param?: any) {
    return this.http
      .get(API_URL, {
        responseType: 'blob',
        headers: new HttpHeaders({
          'Content-Type': 'application/vnd.ms-excel',
        }),
        params: param,
      })
      .pipe(retry(1))
  }

  public getQuoteData_Excel(API_URL: string, param?: any) {
    return this.http
      .post(API_URL, param, {
        responseType: 'blob',
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      })
      .pipe(retry(1))
  }

  public getData_CSV(API_URL: string, param?: any) {
    return this.http
      .get(API_URL, {
        responseType: 'blob',
        headers: new HttpHeaders({
          'Content-Type': 'application/csv',
        }),
        params: param,
      })
      .pipe(retry(1))
  }

  public getData_PDF(API_URL: string, param?: any) {
    return this.http
      .get(API_URL, {
        responseType: 'blob',
        headers: new HttpHeaders({
          'Content-Type': 'application/pdf',
        }),
        params: param,
      })
      .pipe(retry(1))
  }

  public getData_PDF_Detail(API_URL: string, param?: any) {
    return this.http
      .post(API_URL, param, {
        responseType: 'blob',
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      })
      .pipe(retry(1))
  }

  public getData_Doc(API_URL: string, param?: any) {
    return this.http
      .get(API_URL, {
        responseType: 'blob',
        headers: new HttpHeaders({
          'Content-Type': 'application/msword',
        }),
        params: param,
      })
      .pipe(retry(1))
  }
  public getData_JPG(API_URL: string, param?: any) {
    return this.http
      .get(API_URL, {
        responseType: 'blob',
        headers: new HttpHeaders({
          'Content-Type': 'application/jpeg',
        }),
        params: param,
      })
      .pipe(retry(1))
  }
  public getData_PNG(API_URL: string, param?: any) {
    return this.http
      .get(API_URL, {
        responseType: 'blob',
        headers: new HttpHeaders({
          'Content-Type': 'application/png',
        }),
        params: param,
      })
      .pipe(retry(1))
  }
  uploadFileWithProgress(API_URL: string, requestBody: any, options?: any) {
    return this.http.post(API_URL, requestBody, {
      reportProgress: true,
      responseType: 'json',
      observe: 'events',
    })
  }
  public postData(API_URL: string, requestBody: any, options?: any) {
    return this.http.post(API_URL, requestBody, options)
  }

  public deleteData(API_URL: string, id?: any) {
    return this.http.delete(API_URL)
  }
  public deleteMultipleEntries(API_URL: string, requestBody: any) {
    return this.http.delete(API_URL, requestBody)
  }
  public deleteAllData(API_URL: string, id: any) {
    return this.http.delete(API_URL, id)
  }

  public updateData(API_URL: string, param?: any) {
    return this.http.put(API_URL, param)
  }

  public patchData(API_URL: string, requestBody: any, options?: any) {
    return this.http.patch(API_URL, requestBody, options).pipe(retry(1))
  }

  public putData_options(API_URL: string, requestBody: any, options?: any) {
    return this.http.put(API_URL, requestBody, options).pipe(retry(1))
  }

  public putData(API_URL: string, param?: any) {
    return this.http.put(API_URL, param)
  }

  public constructUrl(params: string[]) {
    const preUrl =
      environment.occBaseUrl + environment.occPrefix + environment.occBaseSite
    return preUrl + '/' + params.join('/')
  }

  public getUserData(): Observable<User> {
    return this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccountFacade.get()
        } else {
          return of(undefined)
        }
      })
    )
  }

  setMenuActive(active: boolean) {
    this.menuSubject.next({ activeMenu: active })
  }

  public getMenuActive(): Observable<any> {
    return this.menuSubject.asObservable()
  }

  passMessage(message: string) {
    this.messageSource.next(message)
  }

  sendProduct(product: any) {
    this.productSource.next(product)
  }
  getCount(count: any) {
    this.counterSource.next(count)
  }

  passBOMProducts(BOMPRoducts: any) {
    this.BOMProductSource.next(BOMPRoducts)
  }

  handleError(error) {
    let errorMessage = ''
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`
    }
    /* this.globalMessageService.add(
      'System error, please try again!',
      GlobalMessageType.MSG_TYPE_WARNING
    ); */
    // window.alert(errorMessage);
    return throwError(errorMessage)
  }
}
